import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_component_Message, {
    severity: _ctx.severity,
    icon: _ctx.icon,
    closable: _ctx.closable
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.content), 1)
    ]),
    _: 1
  }, 8, ["severity", "icon", "closable"]))
}